import PropTypes from 'prop-types'
import { unescape as lodashUnescape } from 'lodash'
import { truncate } from '@utils/string.ts'
import PublishStatus from '@constants/publish_statuses.js'
import InternalAccessLevel from '@constants/internal_access_levels.ts'
import SVGIcon from '@components/SVGIcon.tsx'
import Link from '@components/Link.tsx'
import Image from '@components/Image.tsx'
import { containers as resourceActionsContainers } from '@features/resource_actions/index.js'

const { ResourceActionsContainer } = resourceActionsContainers

const TimelineGridItem = props => {
  const { item, timeline, photo } = props

  let elementTitle = lodashUnescape(timeline.title)

  let tags = []
  if (timeline.publish_status_code === PublishStatus.PUBLISHED) {
    tags.push(
      <span className="tag tag--small tag--is-green" key="publish-status-tag">
        Published
      </span>
    )
  } else if (timeline.publish_status_code === PublishStatus.DRAFT) {
    tags.push(
      <span className="tag tag--small tag--is-grey" key="publish-status-tag">
        Draft
      </span>
    )
  }

  let imageContent = null
  if (photo && photo.image_processing_complete === true) {
    const imageSrc = photo.image_urls.large_square.src
    if (imageSrc) {
      imageContent = (
        <Image
          src={imageSrc}
          width={photo.image_urls.large_square.width}
          height={photo.image_urls.large_square.height}
          alt={`${elementTitle} image`}
        />
      )
    }
  }

  const isPrivate = timeline.access_level === InternalAccessLevel.PRIVATE
  let lockIcon = null
  if (isPrivate) {
    lockIcon = (
      <SVGIcon xlinkHref="#streamline-padlock-square-1" className="no-fill" alt="Private" pointerEvents="none" />
    )
  }

  return (
    <div className={`listing-item project-listing-item qa-listing-item-${item.id}`}>
      <div className="project-listing-item__content-container">
        <div className="listing-item__content project-listing-item__content">
          <Link className="listing-item__hit-area" title={elementTitle} href={item.url} />
          <div className="listing-item__image project-listing-item__image">{imageContent}</div>
          <div className="listing-item__body project-listing-item__body">
            <h1 className="heading">
              {lockIcon}
              <span dangerouslySetInnerHTML={{ __html: truncate(timeline.title, 85) }} />
            </h1>
            <div className="tags">{tags}</div>
          </div>
          <div className="listing-item__actions project-listing-item__actions">
            <ResourceActionsContainer
              resourceId={timeline.id}
              resourceType="Timeline"
              wantedActions={['read', 'edit', 'print', 'moderate', 'destroy', 'share', 'publish']}
            />
          </div>
        </div>
      </div>
    </div>
  )
}
TimelineGridItem.propTypes = {
  item: PropTypes.shape({
    id: PropTypes.number.isRequired,
    timeline: PropTypes.number.isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
  timeline: PropTypes.object,
  photo: PropTypes.object,
}

export default TimelineGridItem
